import React from 'react'
import {
  brandColors,
  neutralColors,
  notificationColors,
  textColors,
  backgroundColors,
  iconColors,
  opacityColors,
  gradientColors,
  badgeColors,
} from './Color'

// Define types for the color objects
type ColorMap = { [key: string]: string }

const ColorPanel: React.FC = () => {
  return (
    <div>
      <h2>Brand Colors</h2>
      {Object.keys(brandColors).map((colorKey) => (
        <div
          key={colorKey}
          style={{
            backgroundColor: (brandColors as ColorMap)[colorKey],
            padding: '10px',
            margin: '10px',
            color: colorKey === 'white' ? 'black' : 'white',
          }}
        >
          {colorKey}: {(brandColors as ColorMap)[colorKey]}
        </div>
      ))}

      <h2>Neutral Colors</h2>
      {Object.keys(neutralColors).map((colorKey) => (
        <div
          key={colorKey}
          style={{
            backgroundColor: (neutralColors as ColorMap)[colorKey],
            padding: '10px',
            margin: '10px',
            color: ['greyCloud', 'greyMystic', 'greyAthens', 'greyAlabaster'].includes(colorKey)
              ? 'black'
              : 'white',
          }}
        >
          {colorKey}: {(neutralColors as ColorMap)[colorKey]}
        </div>
      ))}

      <h2>Notification Colors</h2>
      {Object.keys(notificationColors).map((colorKey) => (
        <div
          key={colorKey}
          style={{
            backgroundColor: (notificationColors as ColorMap)[colorKey],
            padding: '10px',
            margin: '10px',
            color: colorKey === 'redLight' || colorKey === 'amberLight' ? 'black' : 'white',
          }}
        >
          {colorKey}: {(notificationColors as ColorMap)[colorKey]}
        </div>
      ))}

      <h2>Text Colors</h2>
      {Object.keys(textColors).map((colorKey) => (
        <div
          key={colorKey}
          style={{
            backgroundColor: (textColors as ColorMap)[colorKey],
            padding: '10px',
            margin: '10px',
            color: ['white', 'greenAccessible'].includes(colorKey) ? 'black' : 'white',
          }}
        >
          {colorKey}: {(textColors as ColorMap)[colorKey]}
        </div>
      ))}

      <h2>Background Colors</h2>
      {Object.keys(backgroundColors).map((colorKey) => (
        <div
          key={colorKey}
          style={{
            background: (backgroundColors as ColorMap)[colorKey],
            padding: '10px',
            margin: '10px',
            color: ['white', 'redLight', 'amberLight', 'greenPanache'].includes(colorKey)
              ? 'black'
              : 'white',
          }}
        >
          {colorKey}: {(backgroundColors as ColorMap)[colorKey]}
        </div>
      ))}

      <h2>Icon Colors</h2>
      {Object.keys(iconColors).map((colorKey) => (
        <div
          key={colorKey}
          style={{
            backgroundColor: (iconColors as ColorMap)[colorKey],
            padding: '10px',
            margin: '10px',
            color: ['redDarker'].includes(colorKey) ? 'white' : 'black',
          }}
        >
          {colorKey}: {(iconColors as ColorMap)[colorKey]}
        </div>
      ))}

      <h2>Opacity Colors</h2>
      {Object.keys(opacityColors).map((colorKey) => (
        <div
          key={colorKey}
          style={{
            backgroundColor: (opacityColors as ColorMap)[colorKey],
            padding: '10px',
            margin: '10px',
            color: ['transparent', 'light10', 'dark10'].includes(colorKey) ? 'black' : 'white',
          }}
        >
          {colorKey}: {(opacityColors as ColorMap)[colorKey]}
        </div>
      ))}

      <h2>Gradient Colors</h2>
      {Object.keys(gradientColors).map((colorKey) => (
        <div
          key={colorKey}
          style={{
            background: (gradientColors as ColorMap)[colorKey],
            padding: '10px',
            margin: '10px',
            color: ['purpleGradient', 'greenGradient', 'brandGradient'].includes(colorKey)
              ? 'white'
              : 'black',
          }}
        >
          {colorKey}: {(gradientColors as ColorMap)[colorKey]}
        </div>
      ))}

      <h2>Badge Colors</h2>
      {Object.keys(badgeColors).map((colorKey) => (
        <div
          key={colorKey}
          style={{
            background: (badgeColors as ColorMap)[colorKey],
            padding: '10px',
            margin: '10px',
            color: ['purpleGradient', 'greenGradient', 'brandGradient'].includes(colorKey)
              ? 'white'
              : 'black',
          }}
        >
          {colorKey}: {(badgeColors as ColorMap)[colorKey]}
        </div>
      ))}
    </div>
  )
}

export default ColorPanel
